import { Injectable } from '@angular/core';

import { RpFavs } from '../public-api';

@Injectable({
    providedIn: 'root',
})
export class SharedTrackingService {
    private myGamesToggle: RpFavs = RpFavs.RECENT;

    setMyGamesToggle(toggle: RpFavs) {
        this.myGamesToggle = toggle;
    }

    getMyGamesToggle(): RpFavs {
        return this.myGamesToggle;
    }
}
